// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___0ebd8f84d6e170ee43e","cls2":"SimplePaperPodcast-cls2___de73c1e84701c824fd5 SimplePaperPodcast-cls1___0ebd8f84d6e170ee43e"};